import { render, staticRenderFns } from "./_multiple.vue?vue&type=template&id=336472a6&"
import script from "./_multiple.vue?vue&type=script&lang=js&"
export * from "./_multiple.vue?vue&type=script&lang=js&"
import style0 from "./_multiple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports